// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2XoWw","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3xYpt"};